export default "__VITE_ASSET__BCAcFZRV__"